import { useState, useContext, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import Title, { CARD_HEADER, CARD_HEADING } from '../custom/Title';
import CustomTabs from '../custom/newTabs';
import {
  createCustomer as createCustomerService,
  updateCustomer as updateCustomerService,
  getCustomer as getCustomerService
} from '../../services/Customer';
import { TCreateCustomerParam, TUpdateCustomerParams } from '../../services/Customer/types';
import { CustomerContext } from '../../contexts/CustomerContext';
import { NotificationContext } from '../../contexts/NotificationContext';
import useService from '../../hooks/useService';
import CustomerBasicDetails from './CustomerBasicDetails';
import CustomerAddress from './CustomerAddress';
import CustomerNominee from './CustomerNominee';
import { PATHS } from '../../utils/constant';



function AddCustomer() {
  const [tabIndex, setTabIndex] = useState(0)
  const { id } = useParams()
  const navigate = useNavigate()
  const {
    customerAddresses,
    customerConfig,
    customerNominee,
    mobileVerificationId
  } = useContext(CustomerContext)

  const { notify } = useContext(NotificationContext)
  const { execute } = useService()
  const [disableSubmit, setDisableSubmit] = useState(true)
  const [fetchLoading, setFetchLoading] = useState(false)
  const [submit, setSubmit] = useState(false)

  console.log('id', mobileVerificationId)
  
  const fetchCustomer = async () => {
    setFetchLoading(true)
    await execute(() => getCustomerService({ customerRefNo: id! }))
    setFetchLoading(false)
  }

  const updateCustomer = (params: TUpdateCustomerParams) => {
    return execute(() => updateCustomerService(params))
  }

  const createCustomer = (params: TCreateCustomerParam) => {
    return execute(() => createCustomerService(params))
  }

  const submitHandler = async () => {
    setSubmit(false)
    if (Object.keys(customerConfig).length === 0) return notify('Please Fill Customer Basic Details', 'error')
    if (customerAddresses.length < 1) return notify('Address is required.', 'error')
    const data = Boolean(id)
      ? {
        customer: {
          ...customerConfig,
          addresses: customerAddresses,
          nominee: Object.keys(customerNominee).length > 0 ? customerNominee : undefined
        },
        customerRefNo: customerConfig.customerRefNo
      } as TUpdateCustomerParams
      : {
        ...customerConfig,
        addresses: customerAddresses,
        nominee: Object.keys(customerNominee).length > 0 ? customerNominee : undefined,
        mobileVerificationId
      } as TCreateCustomerParam

      console.log('id', mobileVerificationId)
    const { error } = Boolean(id)
      ? await updateCustomer(data as TUpdateCustomerParams)
      : await createCustomer(data as TCreateCustomerParam)

    if (error === null){
      notify(id ? 'Customer updated.' : 'Customer created.')
      navigate(PATHS.CUSTOMERS)
    } 
  }


  useEffect(() => {
    if (id) fetchCustomer()
  }, [])

  useEffect(() => {
    if (submit) submitHandler()
  }, [submit])

  useEffect(() => {
    if (Object.keys(customerConfig).length > 0 && customerAddresses.length > 0 && Object.keys(customerNominee).length > 0) {
      setDisableSubmit(false)
    }
  }, [customerConfig, customerAddresses])

  return (
    <div>
      <div style={CARD_HEADER}>
        <Title style={{ ...CARD_HEADING, margin: 0 }}>{id && customerConfig.fullName ? customerConfig.fullName : 'New Customer Setup'}</Title>
      </div>
      <CustomTabs
        labels={[
          'Basic Details',
          'Addresses',
          'Nominee',
        ]}
        TabContents={[
          <CustomerBasicDetails loading={fetchLoading} setIndex={setTabIndex} />,
          <CustomerAddress setIndex={setTabIndex} submit={() => setSubmit(true)} />,
          <CustomerNominee submit={() => setSubmit(true)} />,
        ]}
        value={tabIndex}
        handleChange={setTabIndex}
      />
    </div>
  )
}

export default AddCustomer
